// src/components/atoms/Profile/Edit/CancelButton.js

import React from "react";
import { Button } from "@mui/material";
import { useTheme } from "styled-components";

const CancelButton = ({ onClick }) => {
  const theme = useTheme();

  return (
    <Button
      variant="text"
      color="secondary"
      onClick={onClick}
      sx={{
        textTransform: "none",
        fontFamily: "basic-sans",
        fontSize: "1em",
        color: theme.colors.blue,
        textDecoration: "underline",
        "&:hover": {
          color: theme.colors.red,
        },
      }}
    >
      Cancel
    </Button>
  );
};

export default CancelButton;
